// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-Implications-Implications__wrapper--12_Uf{display:flex;flex:1;position:relative}.src-components-Implications-Implications__explanation---7nh4{font-family:Montserrat,sans-serif;font-weight:400;font-size:13rem;line-height:1.2;box-sizing:border-box;width:413rem;background-color:#fff;min-height:72rem;margin-left:2rem;padding:7rem;position:absolute;will-change:opacity;left:38rem;top:0}", ""]);
// Exports
exports.locals = {
	"wrapper": "src-components-Implications-Implications__wrapper--12_Uf",
	"explanation": "src-components-Implications-Implications__explanation---7nh4"
};
module.exports = exports;
